<template>
  <div>
    <template v-if="isLoad">
      <MobilePayment/>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";
import Contract from "@/mixins/contract";
import MobilePayment from "@/views/MobilePayment";
import { PAYMENT_RESULT_CODE } from "@/constants/constants";

export default {
  props:{

  },

  data() {
    return {
      isLoad: false,
    };
  },

  mixins: [Loader, Contract],
  components: { MobilePayment },
  created() {},

  mounted() {
    this.isLoad = false;
    document.getElementById('container').scrollIntoView({
        behavior: 'instant',
        block: 'start'
    });
    this.loading(async () => {
      const ret = await this.checkExpired();
      if (ret) {
        this.$router.go({ path: "/mobile", force: true });
      }
      else {
        const acinfo = await this.showAccount(await this.showAccountID());
        if (this.isAccountContractPlan(acinfo)) {
          this.$router.push({ name: "mobile-payment-complete", params:{result: PAYMENT_RESULT_CODE.Already, message: "有料プランご契約中です。" } });
        }
        else {
          let isRootUser = false;
          const uid = await this.showUserId();
          if (acinfo.root_users && acinfo.root_users.length > 0) {
            isRootUser = acinfo.root_users.includes(uid);
          }
          if (isRootUser) {
            // 申込可能
            this.isLoad = true;
          }
          else {
            // 申込不可
            this.$router.push({ name: "mobile-payment-complete", params:{result: PAYMENT_RESULT_CODE.Retry} });
          }
        }
      }
    });
  },

  methods: {
    ...mapActions(["showAccount", "showAccountID", "showCurrentUserInfo", "showUserId"]),

    async checkExpired() {
      const currentUserInfo = await this.showCurrentUserInfo();
      if (currentUserInfo === null || currentUserInfo.username === undefined) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
</style>
